const TRANSLATION_CODES = [
  { state: 'Alabama', fips_code: '01'},
  { state: 'Arizona', fips_code: '04'},
  { state: 'Arkansas', fips_code: '05'},
  { state: 'California', fips_code: '06'},
  { state: 'Colorado', fips_code: '08'},
  { state: 'Connecticut', fips_code: '09'},
  { state: 'Delaware', fips_code: '10'},
  { state: 'Florida', fips_code: '12'},
  { state: 'Georgia', fips_code: '13'},
  { state: 'Idaho', fips_code: '16'},
  { state: 'Illinois', fips_code: '17'},
  { state: 'Indiana', fips_code: '18'},
  { state: 'Iowa', fips_code: '19'},
  { state: 'Kansas', fips_code: '20'},
  { state: 'Kentucky', fips_code: '21'},
  { state: 'Louisiana', fips_code: '22'},
  { state: 'Maine', fips_code: '23'},
  { state: 'Maryland', fips_code: '24'},
  { state: 'Massachusetts', fips_code: '25'},
  { state: 'Michigan', fips_code: '26'},
  { state: 'Minnesota', fips_code: '27'},
  { state: 'Mississippi', fips_code: '28'},
  { state: 'Missouri', fips_code: '29'},
  { state: 'Montana', fips_code: '30'},
  { state: 'Nebraska', fips_code: '31'},
  { state: 'Nevada', fips_code: '32'},
  { state: 'New Hampshire', fips_code: '33'},
  { state: 'New Jersey', fips_code: '34'},
  { state: 'New Mexico', fips_code: '35'},
  { state: 'New York', fips_code: '36'},
  { state: 'North Carolina', fips_code: '37'},
  { state: 'North Dakota', fips_code: '38'},
  { state: 'Ohio', fips_code: '39'},
  { state: 'Oklahoma', fips_code: '40'},
  { state: 'Oregon', fips_code: '41'},
  { state: 'Pennsylvania', fips_code: '42'},
  { state: 'Rhode Island', fips_code: '44'},
  { state: 'South Carolina', fips_code: '45'},
  { state: 'South Dakota', fips_code: '46'},
  { state: 'Tennessee', fips_code: '47'},
  { state: 'Texas', fips_code: '48'},
  { state: 'Utah', fips_code: '49'},
  { state: 'Vermont', fips_code: '50'},
  { state: 'Virginia', fips_code: '51'},
  { state: 'Washington', fips_code: '53'},
  { state: 'West Virginia', fips_code: '54'},
  { state: 'Wisconsin', fips_code: '55'},
  { state: 'Wyoming', fips_code: '56'}
];

export default {
  methods: {
    stateCode(county) {
      return TRANSLATION_CODES.find((code) => {
        return code.fips_code === county.substr(0, 2);
      });
    },

    colorList(type) {
      let colors;

      if (type === 'precip' || /^p/.test(type)) {
        colors = [
          '#543005','#8c510a','#bf812d',
          '#dfc27d','#f6e8c3','#c7eae5',
          '#80cdc1','#35978f','#01665e','#003c30'
        ];
      } else {
        colors = [
          '#313695', '#4575b4', '#74add1',
          '#abd9e9', '#e0f3f8', '#fee090',
          '#fdae61', '#f46d43', '#d73027',
          '#a50026'
        ];
      }

      return colors;
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/countyHelpers.js